import { h } from 'preact';

export default function Multiply (props) {
  const { color, size, classes = '', onClick } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      class={classes}
      onClick={onClick}
    >
      <defs />
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-662.000000, -53.000000)"
      >
        <g transform="translate(27.000000, 25.000000)" fill={color || '#FFFFFF'} fillRule="nonzero">
          <g transform="translate(635.000000, 28.000000)">
            <polygon points="2.0609319 0 0 2.0609319 10.4390681 12.5 0 22.9390681 2.0609319 25 12.5 14.5609319 22.9390681 25 25 22.9390681 14.5609319 12.5 25 2.0609319 22.9390681 0 12.5 10.4390681" />
          </g>
        </g>
      </g>
    </svg>
  );
}
